import { render, staticRenderFns } from "./CSummaryList.vue?vue&type=template&id=405db664&"
import script from "./CSummaryList.vue?vue&type=script&lang=js&"
export * from "./CSummaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports